<div class="accordion-wrapper">
  <div class="accordion-header" (click)="toggle()">
    <span class="titulo">DADOS DA INSPEÇÃO</span>
    <svg
      class="arrow"
      [class.open]="isOpen"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path d="M7 10l5 5 5-5H7z" fill="#000" />
    </svg>
  </div>

  <div class="accordion-content" *ngIf="isOpen && itens?.length">
    <table class="tabela">
      <thead>
        <tr>
          <th>Item</th>
          <th>Observações</th>
          <th class="center">Sim</th>
          <th class="center">Não</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of itens; let i = index">
          <td class="descricao">{{ item.descricao }}</td>

          <td>
            <input
              type="text"
              class="input"
              [formControl]="getObservacaoFormControl(i)"
              (click)="$event.stopPropagation()"
              placeholder="Digite uma observação"
            />
          </td>

          <td class="center">
            <div
              class="radio"
              [class.selected]="isRespostaSelecionada(i, 1)"
              (click)="setResposta(i, 1); $event.stopPropagation()"
            ></div>
          </td>

          <td class="center">
            <div
              class="radio"
              [class.selected]="isRespostaSelecionada(i, 0)"
              (click)="setResposta(i, 0); $event.stopPropagation()"
            ></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="accordion-content" *ngIf="isOpen && !itens?.length">
    <p class="sem-itens">Nenhum item de inspeção disponível.</p>
  </div>
</div>
